import React from 'react'
import { Box, Container } from '@mui/material'
import termsHTML from './termsHTML'

export function TermsSection() {
  return (
    <Container maxWidth="lg">
      <Box
        my={10}
        dangerouslySetInnerHTML={{ __html: termsHTML }}
      />
    </Container>
  )
}

export default TermsSection
